import axios from 'axios';

/**
 * add
 */
export const add = data => axios.$callAPI(() => axios.post('depts/', data));

/**
 * 批量删除
 */
export const delAll = ids => axios.$callAPI(() => axios.delete('depts/', { data: ids }));

/**
 * 批量 edit
 */
// export const edits = (datas) => axios.$callAPI(() => axios.patch('depts', datas));

/**
 * 更新部门信息的某些属性值
 */
// export const edits = (data) => axios.$callAPI(() => axios.patch('depts', data));

/**
 * get deptInfo
 */
export const getDeptInfo = id => axios.$callAPI(() => axios.get('/depts/' + id));

/**
 * edit
 */
export const edit = (id, data) => axios.$callAPI(() => axios.put('depts/' + id, data));

/**
 * 删除
 */
export const del = id => axios.$callAPI(() => axios.delete('depts/' + id));

/**
 * get list
 */
export const getDeptList = data => axios.$callAPI(() => axios.get('depts/search', { params: data }));
